/* Revita Derma · comportamento das seções da home (rv-relatos, rv-vitrine, rv-resultados) e vídeos
   preguiçosos. Cada seção se liga pelo próprio elemento, então funciona repetida e no editor de temas. */
(function(){
  const carrega=v=>{if(!v.src&&v.dataset.src)v.src=v.dataset.src;};
  const toca=v=>{carrega(v);const p=v.play();if(p)p.catch(()=>{});};

  /* vídeos com data-auto: tocam mudos só enquanto aparecem */
  const vio='IntersectionObserver' in window?new IntersectionObserver(es=>es.forEach(e=>{e.isIntersecting?toca(e.target):e.target.pause();}),{threshold:.3}):null;

  function relatos(s){
    if(s.dataset.rvOk)return;s.dataset.rvOk=1;
    const sl=s.querySelector('.za-sl'),dots=[...s.querySelectorAll('.za-dots i')];
    let ouvindo=false;
    if(sl&&dots.length){
      const idx=()=>Math.round(sl.scrollLeft/sl.clientWidth);
      const marca=()=>dots.forEach((d,i)=>d.classList.toggle('on',i===idx()));
      sl.addEventListener('scroll',()=>requestAnimationFrame(marca),{passive:true});marca();
      s.querySelectorAll('[data-za]').forEach(b=>b.addEventListener('click',()=>{const n=(idx()+ +b.dataset.za+dots.length)%dots.length;sl.scrollTo({left:n*sl.clientWidth,behavior:'smooth'});}));
      setInterval(()=>{if(document.hidden||ouvindo)return;const n=(idx()+1)%dots.length;sl.scrollTo({left:n*sl.clientWidth,behavior:'smooth'});},9000);
    }
    const rl=s.querySelector('.za-rl');if(!rl)return;
    const reels=[...rl.querySelectorAll('.za-r')].filter(r=>r.querySelector('video'));
    const rotulo=(b,mudo)=>{if(!b)return;b.textContent=mudo?'Ouvir':'Silenciar';b.setAttribute('aria-label',mudo?'Ativar som':'Desativar som');};
    const solo=f=>reels.forEach(r=>{if(r!==f){r.querySelector('video').muted=true;rotulo(r.querySelector('.za-snd'),true);}});
    const rio=vio&&new IntersectionObserver(es=>es.forEach(e=>{const v=e.target.querySelector('video');if(e.isIntersecting)toca(v);else{v.pause();v.muted=true;rotulo(e.target.querySelector('.za-snd'),true);}}),{threshold:.55});
    reels.forEach(r=>{
      if(rio)rio.observe(r);
      const v=r.querySelector('video'),b=r.querySelector('.za-snd');
      const tg=()=>{solo(r);v.muted=!v.muted;rotulo(b,v.muted);ouvindo=!v.muted;if(!v.muted)v.currentTime=0;toca(v);};
      if(b)b.addEventListener('click',e=>{e.stopPropagation();tg();});
      v.addEventListener('click',tg);
    });
    s.querySelectorAll('.za-go').forEach(b=>b.addEventListener('click',()=>{
      const r=rl.querySelectorAll('.za-r')[+b.dataset.reel||0];if(!r)return;const v=r.querySelector('video');if(!v)return;
      rl.scrollTo({left:r.offsetLeft-rl.offsetLeft-16,behavior:'smooth'});
      r.scrollIntoView({behavior:'smooth',block:'center',inline:'nearest'});
      solo(r);v.muted=false;v.currentTime=0;rotulo(r.querySelector('.za-snd'),false);ouvindo=true;toca(v);
    }));
  }

  function vitrine(c){
    if(c.dataset.rvOk)return;c.dataset.rvOk=1;
    const v=c.querySelector('video.h');if(!v)return;
    c.addEventListener('mouseenter',()=>toca(v));
    c.addEventListener('mouseleave',()=>v.pause());
  }

  function resultados(s){
    const zr=s.querySelector('.zr-s');if(!zr||zr.classList.contains('on'))return;
    if(!vio){zr.classList.add('on');return;}
    new IntersectionObserver(([e],o)=>{if(e.isIntersecting){zr.classList.add('on');o.disconnect();}},{threshold:.12}).observe(zr);
  }

  function liga(raiz){
    raiz.querySelectorAll('[data-rv-relatos]').forEach(relatos);
    raiz.querySelectorAll('.zp-c').forEach(vitrine);
    raiz.querySelectorAll('[data-rv-resultados]').forEach(resultados);
    raiz.querySelectorAll('video[data-auto]').forEach(v=>{if(v.dataset.rvOk)return;v.dataset.rvOk=1;vio?vio.observe(v):toca(v);});
    if(matchMedia('(max-width:768px)').matches)raiz.querySelectorAll('img[data-m]').forEach(i=>{if(i.dataset.m)i.src=i.dataset.m;});
  }

  liga(document);
  /* editor de temas: seção adicionada ou recarregada */
  document.addEventListener('shopify:section:load',e=>liga(e.target));
})();
